import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fcb_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const BUSINESS = {
  name: "Faisal Car Bazar",
  phone: "+91 98230 78626",
  phoneDigits: "919823078626",
  address:
    "Telephone Exchange Square, Gangabai Ghat Rd, beside Indian Oil Petrol Pump, Block Number 8, Mangalwari, Nagpur, Maharashtra 440008",
  mapShortLink: "https://maps.app.goo.gl/RSZkEKtKpdzosieaA",
  mapEmbed:
    "https://www.google.com/maps?q=Faisal+Car+Bazar,+Telephone+Exchange+Square,+Gangabai+Ghat+Rd,+Mangalwari,+Nagpur,+Maharashtra+440008&output=embed",
  instagram: "https://instagram.com/faisalcarbazar",
  email: "contact@faisalcarbazar.com",
};

export const waLink = (text) =>
  `https://wa.me/${BUSINESS.phoneDigits}?text=${encodeURIComponent(text || "Hello, I'm interested in your cars.")}`;

export const formatPrice = (n) => {
  if (n == null) return "—";
  if (n >= 10000000) return `₹ ${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹ ${(n / 100000).toFixed(2)} L`;
  return `₹ ${n.toLocaleString("en-IN")}`;
};

export const formatKm = (n) =>
  n == null ? "—" : `${n.toLocaleString("en-IN")} km`;
